import styled from "styled-components";

export const Separator = styled.div`
    width: 100%;
    height: 1px;
    background-color: rgba(0, 0, 0, 0.1);
    margin: 10px 0 15px 0;
`;

export const ExpandedContent = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    min-width: 0;
    margin-top: 10px;
    padding-top: 0;
    box-sizing: border-box;

    .expanded-section {
        display: flex;
        flex-direction: column;
        margin-bottom: 20px;
        width: 100%;
        min-width: 0;

        &:last-child {
            margin-bottom: 0;
        }
    }

    .section-title {
        font-size: 10px;
        font-weight: 600;
        text-transform: uppercase;
        letter-spacing: 0.05em;
        color: ${({ theme }) => theme.colors.interfaceText400 || '#5A646E'};
        margin-bottom: 8px;
    }
`;

export const TableContainer = styled.div`
    width: 100%;
    overflow-x: auto;
    border-radius: 6px;
    border: 1px solid rgba(0, 0, 0, 0.1);

    .data-table {
        width: 100%;
        border-collapse: collapse;
        font-size: 12px;

        thead {
            background-color: ${({ theme }) => theme.colors.interfacePure100 || '#F9FAFB'};

            th {
                text-align: left;
                padding: 8px;
                font-weight: 500;
                font-size: 12px;
                color: ${({ theme }) => theme.colors.c000000};
                white-space: nowrap;

                &.field-col {
                    width: 30%;
                }

                &.value-col {
                    width: 70%;
                }

                &.before-col {
                    width: 35%;
                }

                &.after-col {
                    width: 35%;
                }
            }
        }

        tbody {
            tr {
                &.border-top {
                    border-top: 1px solid rgba(0, 0, 0, 0.1);
                }

                td {
                    padding: 8px;
                    font-size: 12px;
                    color: ${({ theme }) => theme.colors.interfaceText || theme.colors.interfaceText500 || '#020817'};

                    &.field-cell {
                        text-align: left;
                        padding: 8px;
                        font-weight: 500;
                        font-size: 12px;
                        color: rgb(100, 116, 139);
                        white-space: nowrap;
                    }

                    &.value-cell {
                        color: ${({ theme }) => theme.colors.c000000};
                    }

                    &.before-cell {
                        color: rgb(100, 116, 139) !important;
                    }

                    &.after-cell {
                        color: ${({ theme }) => theme.colors.c000000};
                    }

                    &.empty-value {
                        color: ${({ theme }) => theme.colors.interfaceText300 || '#9CA3AF'};
                        font-style: italic;
                    }
                }
            }
        }
    }
`;

export const EmptyState = styled.div`
    padding: 20px;
    text-align: center;
    color: ${(props: any) => props.theme.colors.c64748b};
    font-size: 14px;
`;
